// extracted by mini-css-extract-plugin
export default {"form":"Form_form__e1yzW","label":"Form_label__8nx+5","text":"Form_text__c5Sr+","input":"Form_input__FTtTw","button":"Form_button__8NOIT"};